import { Route, Switch } from "react-router-dom";

import { withCompass } from "../components/compass/withCompass";

const ComponentShowcasePage = withCompass(
  () => import("../pages/ComponentShowcasePage")
);

export function ComponentsRoutes() {
  return (
    <Switch>
      <Route
        path="/components/:componentName"
        component={ComponentShowcasePage}
      />
    </Switch>
  );
}
